import { render, staticRenderFns } from "./Authorizations.vue?vue&type=template&id=29af7922&"
import script from "./Authorizations.vue?vue&type=script&lang=js&"
export * from "./Authorizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports